// extracted by mini-css-extract-plugin
module.exports = {"page":"forgot_page__2c1je","login":"forgot_login__2UE2k","form":"forgot_form__3eS6h"};